import { EuiPageTemplate } from "@inscopix/ideas-eui";
import { Helmet } from "react-helmet-async";
import { usePageProjectData } from "pages/project/usePageProjectData";
import AppLoading from "components/AppLoading/AppLoading";
import { CallOutError } from "components/CallOutError/CallOutError";
import { Route, Switch } from "react-router-dom";
import { ProjectPermissionProvider } from "pages/project/ProjectPermissionProvider";
import { DataTableProvider } from "pages/gdt/store/DataTableProvider";
import { ProjectFoldersProvider } from "pages/gdt/folders/ProjectFoldersProvider";
import { ModalProvider } from "providers/ModalProvider/ModalProvider";
import { PageToolProjectTabs } from "./PageToolProjectTabs";
import { ProjectDataProvider } from "pages/project/ProjectDataProvider";
import { useRouteMapContext } from "providers/RouteMapProvider/RouteMapProvider";
import { PageToolEditor } from "components/ToolEditor/PageToolEditor";
import { useToolDataContext } from "./ToolDataProvider";

export const PageToolProject = () => {
  const { tool } = useToolDataContext();
  const projectKey = tool.project.key;
  const routeMap = useRouteMapContext((s) => s.routeMap);

  const { loading, error, data } = usePageProjectData({ projectKey });

  if (loading && data === undefined) {
    return <AppLoading />;
  }

  if (error) {
    return (
      <EuiPageTemplate>
        <CallOutError message="There was an error loading the project associated with this tool." />
      </EuiPageTemplate>
    );
  }

  const { project } = data;

  return (
    <>
      <Helmet>
        <title>{`${tool.name}`}</title>
      </Helmet>
      <ProjectDataProvider {...data}>
        <ProjectPermissionProvider projectId={project.id}>
          <DataTableProvider projectKey={project.key}>
            <ProjectFoldersProvider projectKey={projectKey}>
              <ModalProvider>
                <Switch>
                  <Route
                    path={[
                      routeMap["TOOL"].parameterizedPath,
                      routeMap["TOOL_TASKS"].parameterizedPath,
                      routeMap["TOOL_FILES"].parameterizedPath,
                      routeMap["TOOL_SETTINGS"].parameterizedPath,
                    ]}
                    exact
                  >
                    <PageToolProjectTabs />
                  </Route>
                  <Route path={routeMap["TOOL_EDITOR"].parameterizedPath} exact>
                    <PageToolEditor />
                  </Route>
                </Switch>
              </ModalProvider>
            </ProjectFoldersProvider>
          </DataTableProvider>
        </ProjectPermissionProvider>
      </ProjectDataProvider>
    </>
  );
};
